import { DiscreteTableLegend } from "./discrete-legend/discrete-legend";

import { ContinueTableLegend } from "./continue-legend/continue-legend";

export function createLegend(option, table) {
    return "color" === option.type || "size" === option.type ? new ContinueTableLegend(option, table) : new DiscreteTableLegend(option, table);
}
//# sourceMappingURL=create-legend.js.map
